import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const styles = {
  customProgressAnimation: {
    animation:
      'MuiCircularProgress-keyframes-circular-rotate 0.7s linear infinite'
  },
  breakLine: {
    whiteSpace: 'pre-line',
    fontSize: 14
  },
  title: {
    textAlign: 'center'
  },
  footer: {
    padding: 20,
    display: 'block'
  },
  modalMobile: {
    maxWidth: 375,
    margin: 'auto'
  }
};

const enhance = compose();

const Main = enhance(
  ({ classes, openProgress, progressOkAction, isFukuoka }) => {
    return (
      <Dialog
        open={openProgress}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        className={classes.modalMobile}
      >
        <DialogTitle id="alert-dialog-title" className={classes.title}>
          {isFukuoka ? '登録完了' : '審査完了'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className={classes.breakLine}
          >
            {isFukuoka
              ? 'グループアカウントの登録が完了しました。グループアカウントでは、複数教室のクーポン情報、コース管理等が可能です。'
              : 'グループアカウントの審査が完了しました。グループアカウントでは、複数店舗の売上、メニュー管理等が可能です。'}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.footer}>
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            onClick={progressOkAction}
          >
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
